export default __webpack_public_path__ + "static/media/LONG-ON.7ac9bd71.png";